import React from 'react';
import ReactDom from 'react-dom';

import CheckoutDurationSelector from '../Components/CheckoutDurationSelector/index.jsx';
import ErrorBoundary from '../Components/ErrorBoundary/index.jsx';


export default function(document) {
  var elements = document.querySelectorAll('[data-react-component="cs-checkout-duration-selector"]');

  if (elements && elements.length) {
    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];
      var title = element.dataset.title;
      var isTrial = element.dataset.isTrial;
      var current = element.dataset.current;
      var currency = element.dataset.currency;
      var group = JSON.parse(element.dataset.group);

      ReactDom.render(
        <ErrorBoundary>
          <CheckoutDurationSelector
            title={title}
            trial={isTrial}
            current={current}
            currency={currency}
            group={group}
          />
        </ErrorBoundary>,
        element
      );
    }
  }
};

